import script from "./DeleteClientConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteClientConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteClientConfirmDropdown.vue?vue&type=style&index=0&id=6a98df04&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a98df04"]])

export default __exports__